import zhCN from './zh-CN'
import zhTW from './zh-TW'
import en from './en'

const messages = { 'zh-CN': zhCN, 'zh-TW': zhTW, en }
const STORAGE_KEY = 'markjy_lang'

function setDocLang(lang) {
  const html = document.documentElement
  html.setAttribute('lang', lang)
  html.className = 'lang-' + lang
  document.title = lang === 'zh-CN' ? 'MARKJY - 问号盒' : lang === 'zh-TW' ? 'MARKJY - 問號盒' : 'MARKJY - UnknownBox'
}

const i18n = {
  install(_Vue) {
    const saved = localStorage.getItem(STORAGE_KEY) || 'zh-CN'
    const state = _Vue.observable({ lang: saved })

    // Methods on Vue.prototype — use _Vue parameter (same instance passed by Vue itself)
    _Vue.prototype.$t = function(key) {
      const lang = state.lang
      return (messages[lang] && messages[lang][key]) || (messages['zh-CN'][key]) || key
    }
    _Vue.prototype.$setLang = function(lang) {
      state.lang = lang
      localStorage.setItem(STORAGE_KEY, lang)
      setDocLang(lang)
    }
    _Vue.prototype.$i18nState = state

    // Static helpers
    _Vue.t = function(key) {
      return (messages[state.lang] && messages[state.lang][key]) || (messages['zh-CN'][key]) || key
    }
    _Vue.getLang = function() {
      return state.lang
    }

    setDocLang(saved)
  }
}

export default i18n
